export default "__VITE_ASSET__4a271229__"